import {getDataWithPromise, handleAjaxError} from "root/DataFunctions/BaseDataFns";

export const ALL_MIS_STATUS = 'ALL';

export const ANY_DATE = 'ANY';

export const getAllWondeWebhookRecordsWithDetails = (status, date_created, onCompleteFunc) =>
{
    //If both status and date come in as null, set a default state
    status = status === null ? ALL_MIS_STATUS : status;
    date_created = date_created === null ? ANY_DATE : date_created;

    const url = Globals.APIFolder + '/writeback/statuses/' + status + '/' + date_created;

    return getDataWithPromise(url, 'GET')
        .then(data =>
        {
            onCompleteFunc(data);
        })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}